<template>
  <div>
    <div class="d-flex justify-content-center" v-if="loading">
      <b-spinner :label="$t('common_phrases.loading')"></b-spinner>
      <RequestInfo :loader="loading"></RequestInfo>
    </div>
    <div v-if="!loading">
      <b-calendar v-model="selectedDate" start-weekday="1" :locale="locale"></b-calendar>
      <div class="errorMsgDiv" v-if="this.errorMessage != null">
        <b-icon
          class="errorMsg"
          icon="exclamation-triangle"
          scale="1.5"
        ></b-icon
        ><span class="errorMsg"> {{ this.errorMessage }}</span>
      </div>
      <p></p>
      <div class="btns">
        <p-button
          :disabled="okDisabled"
          id="ok"
          size="sm"
          outline
          @click="ok()"
          v-b-tooltip
          :title="$t('map.vehicleHistory.ok_button')"
          ><b-icon icon="check2" scale="1.5"></b-icon
        ></p-button>
        <p-button
          id="cancel"
          size="sm"
          outline
          @click="closeSelector()"
          v-b-tooltip
          :title="$t('map.vehicleHistory.close_button')"
          ><b-icon icon="X" scale="1.5"></b-icon
        ></p-button>
      </div>
    </div>
    <VehicleHistoryDetails />
  </div>
</template>

<script>
import mapstore from '@/store/map/mapstore'
//import system from '@/store/system/'
import moment from 'moment'
import VehicleHistoryDetails from '@/components/Realtime/VehicleHistoryDetails'
export default {
  name: 'VehicleHistorySelector',
  components: {
    VehicleHistoryDetails,
  },
  data: function () {
    return {
      /*value: null,*/
      loading: false,
      errorMessage: null,
      selectedDate: null,
      sysTimezone: null,
      beginDate: null,
      okDisabled: true,
      currentStop: null,
      nextStop: null,
      block: null,
      course: null,
      line: null,
      deviation: null,
      latestRouteStop: null,
      nextRouteStop: null,
      tripID: null,
      timestamp: null,
    }
  },
  props: {
    computerLabel: { type: String, default: null },
  },

  beforeCreate: function () {
    if (!this.$store.state.mapstore) {
      this.$store.registerModule('mapstore', mapstore)
    }
    /*if (!this.$store.state.system) {
      this.$store.registerModule("system" , system);
    }*/
  },
  created() {
    this.$bvConfig.setConfig({
      BCalendar: {
        labelHelp: this.$t('datepicker.labelHelp'),
      }
    })
  },
  watch: {
    selectedDate: function () {
      this.okDisabled = false
    },
  },
  mounted() {
    this.$store.dispatch('getSystemParameters').then((data) => {
      this.sysTimezone = data.system_timezone
    })
  },
  computed: {
    locale: function () {
      let locale = this.$i18n.locale
      return locale.replace('_', '-')
    },
  },
  methods: {
    closeSelector: function () {
      this.loading = false
      this.errorMessage = null
      this.$emit('close')
      this.$store.commit('mapstore/setVehicleHistoryData', null)
      this.$store.commit('mapstore/setActiveVehicleHistoryDetails', null)
    },
    ok: function () {
      this.loading = true
      var startDate = new moment(
        this.selectedDate + this.sysTimezone,
        'YYYY-MM-DDZ'
      )
      startDate.utcOffset(this.sysTimezone)
      startDate.set({ hour: 0, minute: 0, second: 0 })
      var endDate = new moment(startDate).add(28, 'hours')
      var attribs = [
        this.$props.computerLabel,
        startDate.format('YYYY-MM-DDTHH:mm:ssZZ'),
        endDate.format('YYYY-MM-DDTHH:mm:ssZZ'),
      ]
      this.$store.dispatch('mapstore/getVehicleHistory', attribs).then(
        (data) => {
          if (data.length == 0) {
            this.loading = false
            this.errorMessage = this.$t('map.vehicleHistory.no_data_error')
            return
          }
          this.$store.commit('mapstore/setVehicleHistoryData', data)
          this.loading = false
          this.errorMessage = null
          this.okDisabled = true
          this.$emit('ok', this.selectedDate)
        },
        () => {
          this.loading = false
          this.errorMessage = this.$t('map.vehicleHistory.data_query_error')
        }
      )
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

div.errorMsgDiv {
  padding-left: 1em;
  padding-top: 1em;
  color: #ffc107;

  span {
    font-size: 0.8em;
    font-weight: bold;
    text-align: center;
    margin-left: 1em;
  }
}

</style>
